/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type MultiSwapOfferMutationVariables = Types.Exact<{
	input: Types.MultiSwapOfferRequest;
}>;

export type MultiSwapOfferMutation = {
	__typename?: "Mutation";
	multiSwapOffer: {
		__typename?: "MultiSwapOfferResponse";
		multiSwapOffer?: {
			__typename?: "MultiSwapOffer";
			swapOfferId: string;
			targetAssetId?: string | null;
			fiatAssetId: string;
			totalTargetAssetAmount: { __typename?: "CurrencyAmount"; value: string };
			totalFiatAssetAmount: { __typename?: "CurrencyAmount"; value: string };
			expiresAt: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
			swapOffers: Array<{
				__typename?: "SwapOffer";
				sourceAssetId: string;
				targetAssetId: string;
				fiatAssetId: string;
				sourceAssetAmount: { __typename?: "CurrencyAmount"; value: string };
				targetAssetAmount: { __typename?: "CurrencyAmount"; value: string };
				fiatAssetAmount: { __typename?: "CurrencyAmount"; value: string };
			} | null>;
		} | null;
	};
};

export const MultiSwapOfferDocument = gql`
	mutation multiSwapOffer($input: MultiSwapOfferRequest!) {
		multiSwapOffer(request: $input) {
			multiSwapOffer {
				swapOfferId
				totalTargetAssetAmount {
					value
				}
				targetAssetId
				totalFiatAssetAmount {
					value
				}
				fiatAssetId
				expiresAt {
					iso8601
					unixTimestamp
				}
				swapOffers {
					sourceAssetId
					sourceAssetAmount {
						value
					}
					targetAssetId
					targetAssetAmount {
						value
					}
					fiatAssetId
					fiatAssetAmount {
						value
					}
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class MultiSwapOfferGQLService extends Apollo.Mutation<MultiSwapOfferMutation, MultiSwapOfferMutationVariables> {
	document = MultiSwapOfferDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
